import { OrderService } from '../services/order.service';
import { Estate } from '../utils/enum.util';
import { ValidatorService, EvalidatorRequire } from '../services/validator.service';
import { BikeModel } from './bike.model';
import { PosturalModel } from './postural.model';
import { isUndefined } from 'util';

export class OrderModel {

    private _id: string                    = null;
    private _created: Date;
    private _client: any;
    private _paid: Date                    = null;
    private _fullBikeLinked: BikeModel     = null;
    private _creator: string               = null;
    private _isOver: boolean               = false;
    private _deliveryWish: Date            = null;
    private _isOffer: boolean              = false;
    private _isAttestation: boolean        = false;
    private _comment: string;
    private _posturalLinked: PosturalModel = null;
    private _inverseBrake: boolean         = false;
    private _clientSize: number            = null;
    private _weightClient: number          = null;
    private _crotchClient: number          = null;
    private _descriptionList: any[]        = [];
    private _price: number                 = null;
    private _magasin: string               = null;
    private _late: boolean               = false;


    private _errors: any;
    private _state: Estate  = Estate.Save;
    private _list: string[] = [
        'Roues',
        'Roue avant',
        'Roue arrière',
        'Groupe',
        'Pédalier',
        'Manivelle',
        'Plateaux',
        'Cassette',
        'Denture',
        'Dérailleur avant',
        'Dérailleur arrière',
        'Manette',
        'Freins',
        'Potence',
        'Guidon',
        'Guidoline',
        'Pneus',
        'Chambres à air',
        'Disques avant',
        'Disques arrière',
        'Selle',
        'Tige de selle',
        'Pédales',
        'Porte-Bidons',
        'Compteur',
        'Support compteur',
        'Chaussure'
    ];

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public orderService: OrderService) {
        this._list.forEach((e)=> {
            this.descriptionList.push({
                title      : e,
                description: null
            });
        });
    };

    static j2o(data, orderService: OrderService) {

        let order = new OrderModel(orderService);

        order._id             = data.id;
        order._created        = new Date(data.created);
        order._client         = data.client;
        order._paid           = data.paid;
        order._fullBikeLinked = null;
        order._creator        = data.creator;
        order._isOver         = order.isOver;
        order._deliveryWish   = new Date(data.deliveryWish);
        order._isOffer        = data.isOffer;
        order._comment        = data.comment;
        order._magasin        = data.magasin;
        order._posturalLinked = data.posturalLinked;
        order._inverseBrake   = data.inverseBrake;
        order._clientSize     = data.clientSize;
        order._weightClient   = data.weightClient;
        order._crotchClient   = data.crotchClient;
        order._price          = data.price;
        order._isAttestation  = data.isAttestation;

        if (data.fullBikeLinked) {
            order._fullBikeLinked = BikeModel.j2o(data.fullBikeLinked, orderService.bikeService, true);
        }

        data.descriptionList.forEach((e)=> {
            order._descriptionList.forEach((f)=> {
                if (e.title == f.title && f.title != 'Autre' && f.title != 'option')
                    f.description = e.description;
            })
        });

        //ajout des options et des autres
        data.descriptionList.forEach((f)=> {
            if (f.title == 'Autre')
                order._descriptionList.push({title: 'Autre', description: f.description});
            else if (f.title == 'option')
                order._descriptionList.push({title: 'option', description: f.description});
        });


        if (isUndefined(order.isOffer))
            order.isOffer = false;
        return order;
    }

    static o2j(order: OrderModel) {

        let tmp = {
            'id'             : order.id,
            'paid'           : order.paid,
            'fullBikeLinked' : null,
            'isOver'         : order.isOver.toString(),
            'deliveryWish'   : order.deliveryWish,
            'isOffer'        : order.isOffer.toString(),
            'comment'        : order.comment,
            'posturalLinked' : null,
            'magasin'        : order.magasin,
            'inverseBrake'   : order.inverseBrake.toString(),
            'clientSize'     : order.clientSize,
            'weightClient'   : order.weightClient,
            'crotchClient'   : order.crotchClient,
            'descriptionList': [],
            'price'          : order.price,
            'isAttestation'  : order.isAttestation.toString()
        };

        if (order.posturalLinked) {
            tmp.posturalLinked = {id: order.posturalLinked.id};
        }

        order.descriptionList.forEach(e=> {
            tmp.descriptionList.push(e);
        });

        if (tmp.descriptionList.length == 0)
            tmp.descriptionList.push({});

        if (order.fullBikeLinked instanceof BikeModel)
            tmp.fullBikeLinked = BikeModel.o2j(order.fullBikeLinked);

        return tmp;
    }

    //*************************************
    //*************** ACTION **************
    //*************************************
    public modelChange() {
        if (this.validate()) {
            this.state = Estate.Saving;
            this.orderService.update(this);
            return true;
        } else {
            this.state = Estate.Error;
            return false;
        }
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this.deliveryWish, 'deliveryWish', EvalidatorRequire.Require, [
                {fn: validator.date, options: {}}
            ])
            .addField(this.clientSize, 'clientSize', EvalidatorRequire.Optional, [
                {fn: validator.integer, options: {min: 1, max: 300}}
            ])
            .addField(this.weightClient, 'weightClient', EvalidatorRequire.Optional, [
                {fn: validator.integer, options: {min: 1, max: 300}}
            ])
            .addField(this.magasin, 'magasin', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 1, max: 20}}
            ])
            .addField(this.fullBikeLinked, 'fullBikeLinked', EvalidatorRequire.Optional, [
                {fn: validator.bike, options: {}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    //*************************************
    //*************** METHOD **************
    //*************************************

    //*************************************
    //********** GETTER / SETTER **********
    //*************************************

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get crotchClient(): number {
        return this._crotchClient;
    }

    set crotchClient(value: number) {
        this._crotchClient = value;
    }

    get created(): Date {
        return this._created;
    }

    set created(value: Date) {
        this._created = value;
    }

    get client(): any {
        return this._client;
    }

    set client(value: any) {
        this._client = value;
    }

    get paid(): Date {
        return this._paid;
    }

    set paid(value: Date) {
        this._paid = value;
    }

    get fullBikeLinked(): BikeModel {
        return this._fullBikeLinked;
    }

    set fullBikeLinked(value: BikeModel) {
        this._fullBikeLinked = value;
    }

    get creator(): string {
        return this._creator;
    }

    set creator(value: string) {
        this._creator = value;
    }

    get isOver(): boolean {
        return this._isOver;
    }

    set isOver(value: boolean) {
        this._isOver = value;
    }

    get deliveryWish(): Date {
        return this._deliveryWish;
    }

    set deliveryWish(value: Date) {
        this._deliveryWish = value;
    }

    get isOffer(): boolean {
        return this._isOffer;
    }

    set isOffer(value: boolean) {
        this._isOffer = value;
    }

    get comment(): string {
        return this._comment;
    }

    set comment(value: string) {
        this._comment = value;
    }

    get posturalLinked(): PosturalModel {
        return this._posturalLinked;
    }

    set posturalLinked(value: PosturalModel) {
        this._posturalLinked = value;
    }

    get inverseBrake(): boolean {
        return this._inverseBrake;
    }

    get magasin(): string {
        return this._magasin;
    }

    set magasin(value: string) {
        this._magasin = value;
    }

    set inverseBrake(value: boolean) {
        this._inverseBrake = value;
    }

    get clientSize(): number {
        return this._clientSize;
    }

    set clientSize(value: number) {
        this._clientSize = value;
    }

    get weightClient(): number {
        return this._weightClient;
    }

    set weightClient(value: number) {
        this._weightClient = value;
    }

    get descriptionList(): any {
        return this._descriptionList;
    }

    set descriptionList(value: any) {
        this._descriptionList = value;
    }

    get price(): number {
        return this._price;
    }

    set price(value: number) {
        this._price = value;
    }

    get errors(): any {
        return this._errors;
    }

    set errors(value: any) {
        this._errors = value;
    }

    get state(): Estate {
        return this._state;
    }

    set state(value: Estate) {
        this._state = value;
    }


    get isAttestation(): boolean {
        return this._isAttestation;
    }

    set isAttestation(value: boolean) {
        this._isAttestation = value;
    }

    get late(): boolean {
        return this._late;
    }

    set late(value: boolean) {
        this._late = value;
    }

    get bikeLinked(): BikeModel {
        return this._fullBikeLinked;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/order.model.ts